import React from 'react';

export default function Error404() {
  return <main id="Error404">
    <h1>404</h1>
    <p>Sorry, it looks like this page does not exist or has been moved</p>
  </main>
}
